import { render, staticRenderFns } from "./SoftSkillsMultiselect.vue?vue&type=template&id=52da29e0"
import script from "./SoftSkillsMultiselect.vue?vue&type=script&lang=ts"
export * from "./SoftSkillsMultiselect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52da29e0')) {
      api.createRecord('52da29e0', component.options)
    } else {
      api.reload('52da29e0', component.options)
    }
    module.hot.accept("./SoftSkillsMultiselect.vue?vue&type=template&id=52da29e0", function () {
      api.rerender('52da29e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/SoftSkillsMultiselect.vue"
export default component.exports